import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDurationTenDays = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={3} height={3} rx={1.5} stroke="#919499" />
    <rect x={4.5} y={12.5} width={3} height={3} rx={1.5} stroke="#919499" />
    <path d="M3.5 2h9a3 3 0 1 1 0 6h-9a3 3 0 1 0 0 6h1" stroke="#919499" />
  </svg>
);
const Memo = memo(SvgDurationTenDays);
export default Memo;
